import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'static', // rewrite from 'relative' because it messes with initial popper-js positioning of the menu element
    },
    title: {},
    dropdown: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1, 2),
      height: theme.spacing(6),
      border: theme.shape.borderGray60,
      backgroundColor: COLORS.neutral.white,
      borderRadius: theme.shape.borderRadius,

      '&$disabled': {
        backgroundColor: COLORS.gray.gray80,
        color: COLORS.gray.gray50,

        '& $icon': {
          color: COLORS.gray.gray50,
        },
      },

      '&$active': {
        borderColor: COLORS.primary.default,
      },

      '&$empty': {
        '& $value': {
          color: COLORS.gray.gray40,
        },
      },

      '&$error': {
        borderColor: COLORS.error.default,
      },
    },
    active: {},
    empty: {},
    disabled: {},
    value: {},
    gray: {
      color: COLORS.gray.gray50,
    },
    icon: {
      fontSize: theme.typography.pxToRem(16),
      marginLeft: 'auto',
    },
    error: {
      marginTop: theme.spacing(0.5),
    },
  }),
  { name: 'BlockImageStyle' }
);
